import { render } from "./adminusermaster.vue?vue&type=template&id=d22075e8&scoped=true"
import script from "./adminusermaster.vue?vue&type=script&lang=js"
export * from "./adminusermaster.vue?vue&type=script&lang=js"

import "./adminusermaster.vue?vue&type=style&index=0&id=d22075e8&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d22075e8"]])

export default __exports__